<template>
  <div :class="['order-data-form', { 'with-error': !noError }]">
    <h2 class="title">Art des Kaufes</h2>
    <form>
      <div class="form-container" style="margin-bottom:20px;">
        <div class="two-inputs-row-wrap">
          <div class="two-inputs-row radio-btns-row">
            <label :class="['input-container', { 'with-error': nameError }]">
              <input v-model="privateBuyer" type="radio" placeholder="Privatkauf" value="private" />
              Privatkauf
            </label>
            <label :class="['input-container', { 'with-error': nameError }]">
              <input v-model="privateBuyer" type="radio" placeholder="gewerblicher Kauf" value="comercial" />
              gewerblicher Kauf
            </label>
          </div>
          <p v-if="privateBuyerError" class="error">Dies ist ein Pflichtfeld.</p>
        </div>
      </div>
    </form>
    <form>
      <div class="form-container">
        <div>
          <h2 class="title" v-if="!isComercial">Ihre Daten</h2>
          <h2 class="title" v-if="isComercial">Ansprechpartner</h2>
          <div class="three-inputs-row-wrap"  style="margin-bottom:36px;flex-grow:0">
            <div class="three-inputs-row radio-btns-row">
              <label :class="['input-container', { 'with-error': nameError }]">
                <input v-model="gender" type="radio" placeholder="Vorname" value="male" />
                Herr
              </label>
              <label :class="['input-container', { 'with-error': nameError }]">
                <input v-model="gender" type="radio" placeholder="Vorname" value="female" />
                Frau
              </label>
              <label :class="['input-container', { 'with-error': nameError }]">
                <input v-model="gender" type="radio" placeholder="Vorname" value="diverse" />
                Divers
              </label>
            </div>
            <p v-if="genderError" class="error">Dies ist ein Pflichtfeld.</p>
          </div>
          <label :class="['input-container', { 'with-error': nameError }]" style="flex-grow:0">
            <input v-model="name" type="text" placeholder="Vorname" />
            <p v-if="nameError" class="error">{{ nameError }}</p>
          </label>
          <label :class="['input-container', { 'with-error': surnameError }]" style="flex-grow:0">
            <input v-model="surname" type="text" placeholder="Nachname" />
            <p v-if="surnameError" class="error">{{ surnameError }}</p>
          </label>
          <div v-if="!isComercial" class="three-inputs-row-wrap" style="flex-grow:0">
            <div class="three-inputs-row">
              <h6>Geburtstag</h6>
              <label :class="['input-container day', { 'with-error': dayBirthError }]">
                <select v-model="dayBirth">
                  <option value="">Tag</option>
                  <option v-for="day in selectOptions.days" :value="day" :key="day">
                    {{ day }}
                  </option>
                </select>
              </label>
              <label :class="['input-container month', { 'with-error': monthBirthError }]">
                <select v-model="monthBirth">
                  <option value="">Monat</option>
                  <option v-for="month in selectOptions.months" :value="month.value" :key="month.name">
                    {{ month.name }}
                  </option>
                </select>
              </label>
              <label :class="['input-container year', { 'with-error': yearBirthError }]">
                <select v-model="yearBirth">
                  <option value="">Jahr</option>
                  <option v-for="year in selectOptions.years" :value="year" :key="year">
                    {{ year }}
                  </option>
                </select>
              </label>
            </div>
            <p v-if="dayBirthError || monthBirthError || yearBirthError" class="error">Dies ist ein Pflichtfeld.</p>
          </div>
          <label :class="['input-container', { 'with-error': phoneError }]" style="flex-grow:0">
            <input :value="phone" type="tel" placeholder="Telefonnummer" @input="changePhone" />
            <p v-if="phoneError" class="error">{{ phoneErrorMessage }}</p>
          </label>
          <label class="input-container" style="flex-grow:0">
            <input :value="order.email" type="text" placeholder="E-Mail Adresse" disabled />
          </label>
        </div>
        <div>
          <h2 class="title" v-if="!isComercial">Rechnungsadresse</h2>
          <h2 class="title" v-if="isComercial">Ihre Firmendaten</h2>

          <label v-if="isComercial" :class="['input-container', { 'with-error': companyNameError }]" style="flex-grow:0">
            <input v-model="companyName" type="text" placeholder="Firmenname" />
            <p v-if="companyNameError" class="error">Dies ist ein Pflichtfeld.</p>
          </label>
          
          <div class="two-inputs-row-wrap">
            <div class="two-inputs-row">
              <label :class="['input-container', { 'with-error': zipError }]">
                <input v-model="zip" type="number" placeholder="PLZ" />
              </label>
              <label :class="['input-container', { 'with-error': cityError }]">
                <input v-model="city" type="text" placeholder="Wohnort" />
              </label>
            </div>
            <p v-if="zipError || cityError" class="error">{{ zipErrorMessage || cityError }}</p>
          </div>

          <label :class="['input-container', { 'with-error': streetError }]" style="flex-grow:0">
            <input v-model="street" type="text" placeholder="Straße und Hausnummer" />
            <p v-if="streetError" class="error">{{ streetError }}</p>
          </label>

          <div v-if="isComercial" class="three-inputs-row-wrap">
            <div class="three-inputs-row">
              <h6>Umsatzsteuer-ID:</h6>
              <label :class="['input-container', { 'with-error': companyTaxError }]" style="margin-right:0; flex:0.4">
                <input v-model="taxInputLetters" type="text" v-mask="'AA'" />
              </label>
              <label :class="['input-container', { 'with-error': companyTaxError }]">
                <input v-model="taxInputNumbers" type="text" v-mask="'#########'" />
              </label>
            </div>
            <p v-if="companyTaxError" class="error">{{ companyTaxErrorMessage ||  'Dies ist ein Pflichtfeld.'}}</p>
          </div>

          <div class="input-container" style="flex-grow:0;margin-bottom:38px;">
            <div style="padding-top:10px">
              <div class="custom-checkbox">
                <input v-model="useDeliveryAddress" id="abweichende-checkbox" type="checkbox" />
                <label for="abweichende-checkbox" />
              </div>
              <b style="margin-left:25px;top:3px;position:relative;">Abweichende Lieferadresse?</b>
            </div>
          </div>

          <template v-if="useDeliveryAddress">
            <label :class="['input-container', { 'with-error': deliveryContactError }]">
              <input v-model="deliveryContact" type="text" placeholder="Vorname Nachname" />
              <p v-if="deliveryContactError" class="error">Dies ist ein Pflichtfeld.</p>
            </label>

            <div class="two-inputs-row-wrap">
              <div class="two-inputs-row">
                <label :class="['input-container', { 'with-error': deliveryZipError }]">
                  <input v-model="deliveryZip" type="number" placeholder="PLZ" />
                </label>
                <label :class="['input-container', { 'with-error': deliveryCityError }]">
                  <input v-model="deliveryCity" type="text" placeholder="Wohnort" />
                </label>
              </div>
              <p v-if="deliveryZipError || deliveryCityError" class="error">{{ deliveryZipErrorMessage || 'Dies ist ein Pflichtfeld.' }}</p>
            </div>

            <label :class="['input-container', { 'with-error': deliveryStreetError }]" style="flex-grow:0">
              <input v-model="deliveryStreet" type="text" placeholder="Straße und Hausnummer" />
              <p v-if="deliveryStreetError" class="error">Dies ist ein Pflichtfeld.</p>
            </label>
            
          </template>

        </div>
        <div v-if="isComercial" class="fleet-hub-container" style="margin-top:10px">
          <img
            src="../assets/images/fleet-hub-logo.svg"
            alt="Fleet Hub"
          />
          <div class="input-container" style="margin-bottom:0;display:flex;align-items:center;">
            <label for="fleet-hub-checkbox">
              <div class="custom-checkbox">
                <input v-model="fleetHub" id="fleet-hub-checkbox" type="checkbox" />
                <label for="fleet-hub-checkbox" />
              </div>
              <b style="margin-left:25px;top:3px;position:relative;">Meine Firma ist Fleet-Hub Kunde</b>
            </label>
          </div>
        </div>
      </div>
      <button class="btn" @click="updateOrderData">{{ editMode ? 'Änderungen übernehmen' : 'Nächster Schritt'}}</button>
    </form>
  </div>
</template>

<script>
import moment from 'moment';
import { checkVAT, countries } from 'jsvat';


const MAX_NAME_LENGTH = 44;
const MAX_SURNAME_LENGTH = 46;
const MAX_STREET_LENGTH = 46;
const MAX_ZIP_LENGTH = 5;
const MAX_TOWN_LENGTH = 44;

const EMPTY_FIELD_MESSAGE = 'Dies ist ein Pflichtfeld.';

const generateValidationMessage = (desiredLength, currentLength) => {
  if (!currentLength) { return EMPTY_FIELD_MESSAGE }

  return `Darf nicht länger als ${desiredLength} Symbole sein. Jetzt sind es ${currentLength}`;
};

export default {
  props: ['order', 'editMode'],
  data() {
    return {
      companyName: this.order.company.name || '',
      companyNameError: false,

      taxInputLetters: this.order.company.tax_number.slice(0, 2) || '',
      taxInputNumbers: this.order.company.tax_number.replace(/[^0-9]+/, '') || '',
      companyTaxError: false,
      companyTaxErrorMessage: '',

      privateBuyer: (this.order.private_buyer ? 'private' : 'comercial') || '',
      privateBuyerError: false,
      name: this.order.name || '',
      nameError: false,
      surname: this.order.surname || '',
      surnameError: false,
      gender: this.order.gender || '',
      genderError: false,
      dayBirth: this.order.birthday ? moment(this.order.birthday, 'YYYY-MM-DD').format('D') : '',
      dayBirthError: false,
      monthBirth: this.order.birthday ? moment(this.order.birthday, 'YYYY-MM-DD').format('MM') : '',
      monthBirthError: false,
      yearBirth: this.order.birthday
        ? moment(this.order.birthday, 'YYYY-MM-DD').format('YYYY')
        : '',
      yearBirthError: false,
      zip: this.order.zip || '',
      zipError: false,
      zipErrorMessage: '',
      city: this.order.city || '',
      cityError: false,
      street: this.order.street || '',
      streetError: false,
      phone: this.order.phone || '',
      phoneError: false,
      phoneErrorMessage: '',

      deliveryContact: this.order.contact_person || '',
      deliveryContactError: false,
      deliveryZip: this.order.delivery_address.zip || '',
      deliveryZipError: false,
      deliveryZipErrorMessage: '',
      deliveryStreet: this.order.delivery_address.street || '',
      deliveryStreetError: false,
      deliveryCity: this.order.delivery_address.city || '',
      deliveryCityError: false,

      useDeliveryAddress: this.order.billing_address.street == this.order.delivery_address.street ? false : true,
      noError: true,

      fleetHub: this.order.fleet_hub ? true : false,
    };
  },
  computed: {
    isComercial() {
      return this.privateBuyer == 'comercial'
    },

    companyTax() {
      return this.taxInputLetters+this.taxInputNumbers;
    },

    isDesktop() {
      return window.innerWidth > 990;
    },
    selectOptions() {
      const days = [];
      const years = [];
      for (let i = 1; i <= 31; i += 1) {
        days.push(i);
      }
      for (let j = 2005; j >= 1920; j -= 1) {
        years.push(j);
      }
      return {
        months: [
          { name: 'Jan', value: '01' },
          { name: 'Feb', value: '02' },
          { name: 'Mär', value: '03' },
          { name: 'Apr', value: '04' },
          { name: 'Mai', value: '05' },
          { name: 'Jun', value: '06' },
          { name: 'Jul', value: '07' },
          { name: 'Aug', value: '08' },
          { name: 'Sep', value: '09' },
          { name: 'Okt', value: '10' },
          { name: 'Nov', value: '11' },
          { name: 'Dez', value: '12' },
        ],
        days,
        years,
      };
    },
  },
  watch: {
    dayBirth(val) {
      if (val && this.dayBirthError) {
        this.dayBirthError = false;
      }
    },
    monthBirth(val) {
      if (val && this.monthBirthError) {
        this.monthBirthError = false;
      }
    },
    yearBirth(val) {
      if (val && this.yearBirthError) {
        this.yearBirthError = false;
      }
    },
    name(val) {
      if (val && this.nameError && val.length <= MAX_NAME_LENGTH) {
        this.nameError = false;
      } else if (!val || val.length > MAX_NAME_LENGTH) {
        this.nameError = generateValidationMessage(MAX_NAME_LENGTH, val.length);
      }
    },
    surname(val) {
      if (val && this.surnameError && val.length <= MAX_SURNAME_LENGTH) {
        this.surnameError = false;
      } else if (!val || val.length > MAX_SURNAME_LENGTH) {
        this.surnameError = generateValidationMessage(MAX_SURNAME_LENGTH, val.length);
      }
    },
    zip(val) {
      if (val && this.zipError) {
        this.zipError = false;
        this.zipErrorMessage = false;
      }
    },
    street(val) {
      if (val && this.streetError && val.length <= MAX_STREET_LENGTH) {
        this.streetError = false;
      } else if (!val || val.length > MAX_STREET_LENGTH) {
        this.streetError = generateValidationMessage(MAX_STREET_LENGTH, val.length);
      }
    },
    phone(val) {
      if (val && this.phoneError) {
        this.phoneError = false;
      }
    },
    city(val) {
      if (val && this.cityError && val.length <= MAX_TOWN_LENGTH) {
        this.cityError = false;
      } else if (!val || val.length > MAX_TOWN_LENGTH) {
        this.cityError = generateValidationMessage(MAX_TOWN_LENGTH, val.length);
      }
    },
    gender(val) {
      if (val && this.genderError) {
        this.genderError = false;
      }
    },
    privateBuyer(val) {
      if (val && this.privateBuyerError) {
        this.privateBuyerError = false;
      }
    },

    companyName(val) {
      if (val && this.companyNameError) {
        this.companyNameError = false;
      }
    },
    companyTax(val) {
      if (val && this.companyTaxError) {
        this.companyTaxError = false;
        this.companyTaxErrorMessage = '';
      }
    },


    deliveryContact(val) {
      if (val && this.deliveryContactError) {
        this.deliveryContactError = false;
      }
    },
    deliveryStreet(val) {
      if (val && this.deliveryStreetError) {
        this.deliveryStreetError = false;
      }
    },
    deliveryCity(val) {
      if (val && this.deliveryCityError) {
        this.deliveryCityError = false;
      }
    },
    deliveryZip(val) {
      if (val && this.deliveryZipError) {
        this.deliveryZipError = false;
      }
    },
  },
  methods: {
    changePhone(e) {
      e.preventDefault();
      const value = e.target.value.trim();
      const currentSymbol = value.slice(-1);
      if (!isNaN(currentSymbol) || this.checkIfSpecialSymbol(currentSymbol)) {
        this.phone = value;
      } else {
        e.target.value = value.slice(0, -1);
        this.phoneError = true;
        this.phoneErrorMessage = 'Bitte geben Sie eine gültige Telefonnummer ein.';
      }
    },
    updateOrderData(e) {
      e.preventDefault();
      const isValid = this.validateForm();
      if (isValid) {
        this.sending = true;
        moment.locale('de');
        let birthday = `${this.yearBirth}-${this.monthBirth}-${this.dayBirth}`;
        let delivery = {};
        let params = {};

        if (this.useDeliveryAddress) {
          delivery = {
            contact_person: this.deliveryContact,
            delivery_address: {
              city: this.deliveryCity,
              street: this.deliveryStreet,
              zip: this.deliveryZip
            }
          }
        } else {
          delivery = {
            contact_person: '',
            delivery_address: {
              city: this.city,
              street: this.street,
              zip: this.zip
            }
          }
        }
        if (this.isComercial) {
          params = {
            private_buyer: false,
            name: this.name,
            surname: this.surname,
            phone: this.phone,
            street: this.street,
            city: this.city,
            zip: this.zip,
            gender: this.gender,
            company_name: this.companyName,
            company_tax_number: this.companyTax,
            birthday: '',
            ...delivery,
            fleet_hub: this.fleetHub,
          };
        } else {
          params = {
            private_buyer: true,
            name: this.name,
            surname: this.surname,
            phone: this.phone,
            street: this.street,
            city: this.city,
            zip: this.zip,
            gender: this.gender,
            company_name: '',
            company_tax_number: '',
            birthday,
            ...delivery
          };
        }
        
        this.$emit('updateOrderStep', this.order.token, params);
      }
    },
    checkIfSpecialSymbol(value) {
      const re = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
      return re.test(value);
    },
    validatePhone(value) {
      const phoneRe = /^\+?\d+(-\d+)*$/;
      const digits = value.replace(/\D/g, '');
      return phoneRe.test(digits);
    },
    validateForm() {
      let noError = true;
      if (!this.privateBuyer) {
        this.privateBuyerError = true;
        noError = false;
      } else {
        this.privateBuyerError = false;
      }

      if (!this.name) {
        this.nameError = EMPTY_FIELD_MESSAGE;
        noError = false;
      } else if (this.name.length > MAX_NAME_LENGTH) {
        this.nameError = generateValidationMessage(MAX_NAME_LENGTH, this.name.length);
        noError = false;
      } else {
        this.nameError = false;
      }

      if (!this.surname) {
        this.surnameError = EMPTY_FIELD_MESSAGE;
        noError = false;
      } else if (this.surname.length > MAX_SURNAME_LENGTH) {
        this.surnameError = generateValidationMessage(MAX_SURNAME_LENGTH, this.surname.length);
        noError = false;
      } else {
        this.surnameError = false;
      }

      if (!this.gender) {
        this.genderError = true;
        noError = false;
      } else {
        this.genderError = false;
      }
      if (!this.zip) {
        this.zipError = true;
        this.zipErrorMessage = 'Dies ist ein Pflichtfeld.';
        noError = false;
      } else if (this.zip.length !== 5) {
        this.zipError = true;
        this.zipErrorMessage = 'Bitte geben Sie eine gültige PLZ ein.';
        noError = false;
      } else {
        this.zipError = false;
      }


      if (!this.city) {
        this.cityError = EMPTY_FIELD_MESSAGE;
        noError = false;
      } else if (this.city.length > MAX_TOWN_LENGTH) {
        this.cityError = generateValidationMessage(MAX_TOWN_LENGTH, this.city.length);
        noError = false;
      } else {
        this.cityError = false;
      }

      if (!this.street) {
        this.streetError = EMPTY_FIELD_MESSAGE;
        noError = false;
      } else if (this.street.length > MAX_STREET_LENGTH) {
        this.streetError = generateValidationMessage(MAX_STREET_LENGTH, this.street.length);
        noError = false;
      } else {
        this.streetError = false;
      }

      // perform this checks only on comercial
      if (this.isComercial) {

        if (!this.companyName) {
          this.companyNameError = true;
          noError = false;
        } else {
          this.companyNameError = false;
        }

        if (!this.companyTax) {
          this.companyTaxError = true;
          noError = false;
        } else if(!checkVAT(this.companyTax, countries).isValidFormat) {
          this.companyTaxError = true;
          this.companyTaxErrorMessage = 'Keine gültige Umsatzsteuer-id.';
          noError = false;
        } else {
          this.companyTaxError = false;
        }
        
      // perform this checks only on private
      } else {
        if (!this.dayBirth) {
          this.dayBirthError = true;
          noError = false;
        } else {
          this.dayBirthError = false;
        }
        if (!this.monthBirth) {
          this.monthBirthError = true;
          noError = false;
        } else {
          this.monthBirthError = false;
        }
        if (!this.yearBirth) {
          this.yearBirthError = true;
          noError = false;
        } else {
          this.yearBirthError = false;
        }
      }

      // perform this checks only if delivery address is used
      if (this.useDeliveryAddress) {
        if (!this.deliveryContact) {
          this.deliveryContactError = true;
          noError = false;
        } else {
          this.deliveryContactError = false;
        }
        if (!this.deliveryStreet) {
          this.deliveryStreetError = true;
          noError = false;
        } else {
          this.deliveryStreetError = false;
        }
        if (!this.deliveryZip) {
          this.deliveryZipError = true;
          this.deliveryZipErrorMessage = 'Dies ist ein Pflichtfeld.';
          noError = false;
        } else if (this.deliveryZip.length !== 5) {
          this.deliveryZipError = true;
          this.deliveryZipErrorMessage = 'Bitte geben Sie eine gültige PLZ ein.';
          noError = false;
        } else {
          this.deliveryZipError = false;
        }
        if (!this.deliveryCity) {
          this.deliveryCityError = true;
          noError = false;
        } else {
          this.deliveryCityError = false;
        }
      }
      
      if (!this.phone) {
        this.phoneError = true;
        this.phoneErrorMessage = 'Dies ist ein Pflichtfeld.';
        noError = false;
      } else if (this.phone.length < 9 && this.validatePhone(this.phone)) {
        this.phoneError = true;
        this.phoneErrorMessage = 'Bitte geben Sie eine gültige Telefonnummer ein.';
        noError = false;
      } else {
        this.phoneError = false;
      }
      if (noError) {
        this.privateBuyerError = false;
        this.nameError = false;
        this.surnameError = false;
        this.dayBirthError = false;
        this.monthBirthError = false;
        this.yearBirthError = false;
        this.zipError = false;
        this.cityError = false;
        this.streetError = false;
        this.phoneError = false;
        this.genderError = false;

        this.companyNameError = false;
        this.companyTaxError = false;

        this.deliveryContactError = false;
        this.deliveryZipError = false;
        this.deliveryStreetError = false;
        this.deliveryCityError = false;
      }
      this.noError = noError;
      return noError;
    },
  },
};
</script>

<style lang="scss" scoped>
.order-data-form {
  padding: 30px 0.625rem;

  .btn {
    margin-left: auto;
  }

  @include breakpoint(desktop) {
    padding: 30px 0;
  }
  .three-inputs-row-wrap {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .error {
      display: block;
      padding: 5px 0;
      font-size: 12px;
      line-height: 12px;
      color: $red;
    }
  }

  .two-inputs-row-wrap {
    
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    .error {
      display: block;
      padding: 5px 0;
      font-size: 12px;
      line-height: 12px;
      color: $red;
    }
    .input-container {
      margin-right: 0;
    }
  }

  .two-inputs-row {
    display: flex;
    .input-container {
      flex: 1;
      margin-bottom: 0;
      &:first-child {
        flex: 0.5;
      }
      margin-right: 0;
    }
  }

  .three-inputs-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.radio-btns-row {
      padding-top: 12px;
    }
    > * {
      flex: 1;
      margin-right: 10px;
      &.day {
        flex: 0.8;
      }
      &:last-child {
        margin-right: 0;
      }
    }
    h6 {
      font-size: 15px;
      font-weight: normal;
      line-height: 1.25;
    }
    .input-container {
      margin-bottom: 0;
      select {
        height: 46px;
        padding: 12px 6px 12px 8px;
        font-size: 14px;
      }
    }
  }
  .form-container {
    & > div {
      &.fleet-hub-container {
        border:1px solid #d0d0d0;
        padding:10px 20px 20px;
        margin-bottom:25px;
        display:flex;
        flex-wrap:wrap;
        justify-content: space-between;
        align-items: center;

        img {
          margin-bottom: 10px;
        }
      }
    }
  }
  @include breakpoint(desktop) {
    .form-container {
      display: flex;
      justify-content: space-between;
      flex-wrap:wrap;
    }
    .form-container > div {
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      // flex: 1;
      flex-basis:48%;
      &:first-child {
        margin-right: 20px;
      }
      &.fleet-hub-container {
        // flex: 2;
        flex-basis:100%;
      }
      .input-container {
        flex: 1;
      }
      .two-inputs-row {
        .input-container {
          &:first-child {
            flex: 0.5;
          }
          margin-right: 0;
        }
      }
      .three-inputs-row-wrap {
        flex: 0;
      }
      .three-inputs-row {
        .input-container {
          &.months {
            flex: 2;
          }
        }
      }

      &.fleet-hub-container {
        display:flex;
        justify-content: space-between;
        align-items:center;
        flex-grow:1;
        flex-direction: row;
        border:1px solid #d0d0d0;
        padding:15px 20px;
        margin-bottom:0;
        
        img {
          margin-bottom:0;
        }

        .input-container {
          flex:none;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.input-container {
  input[type='text'].mx-input {
    display: block;
    height: 100%;
    padding: 13px 12px;
  }
}
</style>
